"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Метод получения ФИО пользователя системы
 * @param user - пользователь системы
 */
function getUserFullName(user) {
    return user.lastName + ' ' + user.firstName + (user.middleName ? ' ' + user.middleName : '');
}
exports.getUserFullName = getUserFullName;
//# sourceMappingURL=index.js.map